import React from "react";

import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";
import { ReactComponent as AudienceOverlapIcon } from "src/images/audience-overlap.svg";

export default function AudienceOverlapButton({
  showAudienceOverlapPane,
  isAudienceOverPageLimit,
  influencersInList,
}) {
  const areInListAtLeastTwoInfluencers = (influencersInList?.length ?? 0) > 1;
  return (
    <MaterialTooltip
      center
      content={
        isAudienceOverPageLimit ? (
          <IDHFormattedMessage
            id="front_available_disable_audience_overlap_over_limit_tooltip"
            defaultMessage="Available only under 100 selected Creators list."
          />
        ) : (
          <IDHFormattedMessage
            id="front_select_at_least_two_creators_from_the_list_tooltip"
            defaultMessage="Select at least two creators from the list."
          />
        )
      }
      contentHidden={!isAudienceOverPageLimit && areInListAtLeastTwoInfluencers}
    >
      <Button
        size="medium"
        variant="white"
        onClick={showAudienceOverlapPane}
        className="audience-results-page__overlap-btn"
        disabled={isAudienceOverPageLimit || !areInListAtLeastTwoInfluencers}
        data-qa="audience-overlap-button"
      >
        <AudienceOverlapIcon className="icon-left" />
        <IDHFormattedMessage
          id="front_audience_overlap"
          defaultMessage="Audience Overlap"
        />
      </Button>
    </MaterialTooltip>
  );
}
